module.exports = "<loading-bar></loading-bar>\n<nav-bar></nav-bar>\n<modal-password></modal-password>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main